export default {
  home_challenge_skill_id: 0,
  criterion_list: {},
  criterionValues: {},
  criterionToday: [],
  availableDates: {},
  editableDates: [],

  criterionCategories: [],
  criterionImages: [],
  criterionTimeFrequencyChoices: [],
  criterionTimeDayChoices: [],
  criterionDaysOfWeek: [],
  predefinedCriterion: [],
  posibleStarsToday: 0,
  starsEarned: 0,
  error: '',
};
